import { render, staticRenderFns } from "./formKewajiban.vue?vue&type=template&id=38f17eda&"
import script from "./formKewajiban.vue?vue&type=script&lang=js&"
export * from "./formKewajiban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports